<button [matMenuTriggerFor]="menu" class="icon-menu__button" matButton>
	<digital-components-kit-avatar
		[avatarUrl]="
			this.accountService.profileInformations?.picture === ''
				? picture
				: this.accountService.profileInformations?.picture
		"
		[firstname]="
			this.accountService.profileInformations?.firstname === ''
				? firstname
				: this.accountService.profileInformations?.firstname
		"
		[lastname]="
			this.accountService.profileInformations?.lastname === ''
				? lastname
				: this.accountService.profileInformations?.lastname
		"
		class="me-2"
	>
	</digital-components-kit-avatar>
	<span
	>{{
			this.accountService.profileInformations?.firstname === ''
				? firstname
				: this.accountService.profileInformations?.firstname
		}}
		{{
			this.accountService.profileInformations?.lastname === ''
				? lastname
				: this.accountService.profileInformations?.lastname
		}}</span
	>
	<mat-icon class="order-2 icon-menu__button-icon material-symbols-rounded">expand_more</mat-icon>
</button>
<mat-menu #menu="matMenu" backdropClass="icon_menu">
  <app-user-profile-menu></app-user-profile-menu>
</mat-menu>
